export default __webpack_public_path__ + "bml-characteristic2.24de8b8.png";